import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const USER_KEY = "tdf_free_user";

const TrackingContext = createContext({ user: null, signup: async () => {}, isSignedUp: false });

export function useTracking() { return useContext(TrackingContext); }

export function TrackingProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem(USER_KEY) || "null"); } catch { return null; }
  });
  const location = useLocation();

  const signup = useCallback(async (email, firstName, source = "popup") => {
    const res = await axios.post(`${API}/users/signup`, { email, first_name: firstName, source });
    const u = { id: res.data.user_id, email: res.data.email, first_name: firstName || "" };
    localStorage.setItem(USER_KEY, JSON.stringify(u));
    setUser(u);
    return u;
  }, []);

  // Track every route change (and skip admin routes)
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    const ctrl = new AbortController();
    axios.post(`${API}/track`, {
      user_id: user?.id || null,
      path: location.pathname,
      referrer: document.referrer || "",
      title: document.title || "",
    }, { signal: ctrl.signal }).catch(() => {});
    return () => ctrl.abort();
  }, [location.pathname, user?.id]);

  return (
    <TrackingContext.Provider value={{ user, signup, isSignedUp: !!user }}>
      {children}
    </TrackingContext.Provider>
  );
}
